import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgFrameworkComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { EQueryStatus } from '../../../e-queries/models/e-query-status';
import { ResponseAgeInfo } from '../../../e-queries/response-age-info';

@Component({
    selector: 'response-age-cell',
    template: require('./response-age-renderer.component.html'),
    styles: [require('./response-age-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResponseAgeRendererComponent implements AgFrameworkComponent<ICellRendererParams> {
    public value: string;
    public isExpired = false;
    public agInit(params: { data: ResponseAgeInfo }): void {
        const ageInfo = params.data;
        if (ageInfo) {
            const distance = ageInfo.responseAge;
            this.value = distance ? distance.formattedValue : null;
            this.isExpired = distance && distance.days >= 1 ? true : false;
        }
    }
}
